import {selPropGen} from 'module/Properties/selector/selPropGen'
import {PropID} from 'module/Properties/enum/PropID'
import {propDefaultFalse, propDefaultTrue} from 'module/Properties/util/PropertiesUtil'

const base = {
	label: 'Ist-Zeit',
	type: 'boolean',
	visibleSelector: selPropGen(PropID.istVis, propDefaultTrue),
} as const

export const IstZeitUserConfigDict = {
	enabled: {
		...base,
		defaultValue: false,
		defaultOverrideSelector: selPropGen(PropID.istDefault, propDefaultFalse),
	},
} as const

export const IstZeitUserConfigDefaultOnDict = {
	enabled: {
		...base,
		defaultValue: true,
		defaultOverrideSelector: selPropGen(PropID.istDefault, propDefaultTrue),
	},
} as const